import React from 'react';
import { withTheme } from 'styled-components';
export var IconAward = withTheme(function (_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "51",
    height: "51",
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    clipPath: "url(#clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6794 5.09635C18.7758 5.09635 13.1794 10.6928 13.1794 17.5964C13.1794 24.4999 18.7758 30.0964 25.6794 30.0964C32.5829 30.0964 38.1794 24.4999 38.1794 17.5964C38.1794 10.6928 32.5829 5.09635 25.6794 5.09635ZM9.0127 17.5964C9.0127 8.39161 16.4746 0.929688 25.6794 0.929688C34.8841 0.929688 42.346 8.39161 42.346 17.5964C42.346 26.8011 34.8841 34.263 25.6794 34.263C16.4746 34.263 9.0127 26.8011 9.0127 17.5964Z",
    fill: theme.colors.primary
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3013 27.7812C34.4419 27.6298 35.4892 28.4318 35.6406 29.5724L38.1614 48.5724C38.2666 49.3654 37.9085 50.1486 37.2399 50.5877C36.5712 51.0269 35.7102 51.0444 35.0243 50.6328L25.6795 45.026L16.3347 50.6328C15.6487 51.0444 14.7876 51.0269 14.119 50.5876C13.4504 50.1484 13.0923 49.3651 13.1976 48.5721L15.7185 29.5929C15.87 28.4523 16.9174 27.6505 18.058 27.802C19.1985 27.9535 20.0003 29.0009 19.8489 30.1415L17.8971 44.8363L24.6076 40.8099C25.2674 40.4141 26.0916 40.4141 26.7514 40.8099L33.4626 44.8367L31.5101 30.1204C31.3588 28.9798 32.1607 27.9325 33.3013 27.7812Z",
    fill: theme.colors.primary
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0"
  }, React.createElement("rect", {
    width: "50",
    height: "50",
    fill: "white",
    transform: "translate(0.679443 0.929688)"
  }))));
});